import { Icon } from './Icon';
import { v } from '@/theme/tokens';
import { Button } from './Button';

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div
      role="alert"
      className="rt-banner"
      style={{
        border: `1px solid ${v('negative-soft')}`,
        background: v('negative-soft'),
        padding: 20,
        display: 'flex',
        gap: 14,
        alignItems: 'flex-start',
      }}
    >
      <div style={{ color: v('negative'), marginTop: 2 }}>
        <Icon name="alert" size={20} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: v('negative') }}>Ошибка</div>
        <div style={{ fontSize: 13.5, color: v('ink-sub'), marginTop: 4 }}>{message}</div>
      </div>
      {onRetry && <Button onClick={onRetry}>Повторить</Button>}
    </div>
  );
}
